import React, { Component } from 'react'
import OrchestraArrangePlayer from './OrchestraArrangePlayer'
import { Resizable, ResizableBox } from 'react-resizable';
import LoadingSpinner from '../LoadingSpinner'
import classNames from './OrchestraArrange.css'
import OrchestraArrangeSpawner from './OrchestraArrangeSpawner';

export default class OrchestraArrange extends Component {
  state = {
    loaded: false,
    dimensions: null,
    scaleFactor: 1
  }
  componentDidMount () {
    this.mounted = true;
    this.getContainerDimensions();
    // window.addEventListener('resize', this.getContainerDimensions);
  }
  componentWillUnmount () {
    // window.removeEventListener('resize', this.getContainerDimensions);
  }
  getContainerDimensions = () => {
    if (this.mounted) {
      this.setState({
        dimensions: {
          width: this.container.offsetWidth,
          height: this.container.offsetHeight,
        },
      }, this.calculateScaleFactor);
    }
  }
  onPlayerMove = (playerId, playerPos) => {
    let formation = this.props.sceneFormation;
    const {scaleFactor} = this.state;

    // update the player position
    let player = formation.players.find((player) => { return player.id === playerId; });
    player.x_pos = playerPos.x_pos * scaleFactor;
    player.y_pos = playerPos.y_pos * scaleFactor;

    // send to server
    this.props.onFormationChange(formation);
  }
  onSceneResizeEnd = (e, data) => {
    const {scaleFactor} = this.state;
    const {sceneFormation} = this.props;
    sceneFormation.scene_width = data.size.width * scaleFactor;
    sceneFormation.scene_height = data.size.height * scaleFactor;
    this.props.onFormationChange(sceneFormation);
  }
  onSceneWidthChange = (newWidth) => {
    let {sceneFormation} = this.props;
    sceneFormation.scene_width = newWidth;
    this.props.onFormationChange(sceneFormation);
  }
  onSceneHeightChange = (newHeight) => {
    let {sceneFormation} = this.props;
    sceneFormation.scene_height = newHeight;
    this.props.onFormationChange(sceneFormation);
  }
  onSceneScaleChange = (newScale) => {
    this.setState({scaleFactor: newScale});
  }
  onSpawnPosDrag = (_, data) => {
    const { sceneFormation } = this.props;
    sceneFormation.scene_preferences.spawn_x.value = data.x * this.state.scaleFactor;
    sceneFormation.scene_preferences.spawn_y.value = data.y * this.state.scaleFactor;
    this.props.onPrefChange(sceneFormation.scene_preferences);
  }
  calculateScaleFactor = () => {
    const {width, height} = this.state.dimensions;
    const {scene_width, scene_height} = this.props.sceneFormation;
    let scaleFactor = 1;

    // increase scale factor until everything fits!
    while ((scene_width / scaleFactor) >= width || (scene_height / scaleFactor) >= height) {
      scaleFactor++;
    }
    this.setState({ scaleFactor: scaleFactor });
  }
  scaleDimension = (dimensionValue) => {
    let scaled = Math.floor(dimensionValue / this.state.scaleFactor)
    return scaled;
  }
  renderExtraForSceneType = (type, formation) => {
    if (type.toLowerCase() === 'floating') {
      const prefs = formation.scene_preferences;
      if (prefs && prefs.spawn_x) {
        return (
          <OrchestraArrangeSpawner
            xPos={this.scaleDimension(prefs.spawn_x.value)}
            yPos={this.scaleDimension(prefs.spawn_y.value)}
            angleRad={prefs.spawn_angle.value}
            breadth={this.scaleDimension(prefs.spawn_breadth.value)}
            onStop={this.onSpawnPosDrag}
          />
        );
      }
    }
  }
  renderActions = (actions) => {
    if (actions.length) {
      return (
        <div>
          <h2>Actions</h2>
          <div className={classNames.arrangerMenu}>
            {/* <button onClick={this.props.sendShrinkWrap}>Shrink-wrap</button> */}
            <button onClick={this.props.getJoinLink}>Create join link</button>
          </div>
        </div>
      );
    }
  }
  render () {
    const { sceneFormation, selectedPlayerId } = this.props
    const { scaleFactor } = this.state

    if (sceneFormation) {
      // TODO: only render actions if there are any...
      const actions = [];
      return (
        <div className={classNames.arrangerContainer} ref={el => (this.container = el)}>
          { this.renderActions(actions) }
          {/* Guaranteed properties */}
          <span>Width: </span>
          <input
            type='number'
            value={sceneFormation.scene_width}
            min={1}
            className={classNames.numberInput}
            onChange={e => this.onSceneWidthChange(parseInt(e.target.value))}
          />
          <span>Height: </span>
          <input
            type='number'
            value={sceneFormation.scene_height}
            min={1}
            className={classNames.numberInput}
            onChange={e => this.onSceneHeightChange(parseInt(e.target.value))}
          />
          <span>Scale: </span>
          <input
            type='number'
            value={scaleFactor}
            min={1}
            max={10}
            step={1}
            className={classNames.numberInput}
            onChange={e => this.onSceneScaleChange(parseFloat(e.target.value))}
          />
          <h2>Layout</h2>
            <ResizableBox
              width={this.scaleDimension(sceneFormation.scene_width)}
              height={this.scaleDimension(sceneFormation.scene_height)}
              minConstraints={[this.scaleDimension(100), this.scaleDimension(100)]}
              onResizeStop={this.onSceneResizeEnd}
            >
              <span>
              <div className={classNames.scene}>
                {this.props.sceneFormation.players.map((player) => {
                  let playerStyle = {
                    width: this.scaleDimension(player.width),
                    height: this.scaleDimension(player.height)
                  }
                  let selected = player.id == selectedPlayerId
                  return (<OrchestraArrangePlayer
                    key={player.id}
                    style={playerStyle}
                    id={player.id}
                    name={player.name}
                    connected={player.connected}
                    selected={selected}
                    position={{x: this.scaleDimension(player.x_pos), y: this.scaleDimension(player.y_pos) }}
                    onPlayerMove={this.onPlayerMove}
                    identifyPlayer={this.props.identifyPlayer}
                    onPlayerClicked={this.props.onPlayerClicked}
                    width={player.width}
                    height={player.height}
                  />)
                })}
              </div>
              </span>
              { this.renderExtraForSceneType(sceneFormation.scene_type, sceneFormation) }

            </ResizableBox>
        </div>
      );
    } else {
      return (
        <div ref={el => (this.container = el)}>
          <h2>Connecting to Orchestra websocket...</h2>
          <LoadingSpinner />
        </div>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/orchestra/OrchestraArrange.js